export enum Routes {
  FleetTransferRouter = "*",
  TransferSearchPageRouter = "/fleet/transfer/search",
}
